// @generated by liquid-inject from src/sections/algolia-filter/algolia-filter.ts
// src/shared/algolia/filter-form.ts
var ALGOLIA_FILTER_FORM_SELECTOR = "[data-ais-sort-config] form#form-filter";
var ALGOLIA_DYNAMIC_BUTTON_SELECTOR = "[data-ais-refinements] button, [data-ais-sort] button, [data-ais-clear] button";
var ALGOLIA_DYNAMIC_ZONE_SELECTOR = "[data-ais-refinements], [data-ais-sort], [data-ais-clear]";
var ALGOLIA_SCROLL_PRESERVE_SELECTOR = "[data-ais-refinements] input, [data-ais-refinements] button";
function setAlgoliaFilterButtonTypes(scope) {
  scope.querySelectorAll(ALGOLIA_DYNAMIC_BUTTON_SELECTOR).forEach((button) => {
    if (!button.hasAttribute("type")) {
      button.type = "button";
    }
  });
}
function setButtonTypesForAddedNode(node) {
  if (!(node instanceof Element)) return;
  if (node instanceof HTMLButtonElement && !node.hasAttribute("type") && node.closest(ALGOLIA_DYNAMIC_ZONE_SELECTOR)) {
    node.type = "button";
    return;
  }
  if (node.closest(ALGOLIA_DYNAMIC_ZONE_SELECTOR)) {
    node.querySelectorAll("button").forEach((button) => {
      if (!button.hasAttribute("type")) {
        button.type = "button";
      }
    });
    return;
  }
  setAlgoliaFilterButtonTypes(node);
}
function setupAlgoliaFilterForm(form) {
  if (form.dataset.algoliaSubmitGuard === "true") return;
  let preservedScrollTop = null;
  let forgetTimeout = null;
  let frame = null;
  let pending = [];
  const preserveScroll = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(ALGOLIA_SCROLL_PRESERVE_SELECTOR)) return;
    preservedScrollTop = form.scrollTop;
  };
  const flush = () => {
    frame = null;
    const nodes = pending;
    pending = [];
    for (const node of nodes) {
      setButtonTypesForAddedNode(node);
    }
    if (preservedScrollTop === null) return;
    form.scrollTop = preservedScrollTop;
    if (forgetTimeout !== null) window.clearTimeout(forgetTimeout);
    forgetTimeout = window.setTimeout(() => {
      preservedScrollTop = null;
      forgetTimeout = null;
    }, 200);
  };
  form.dataset.algoliaSubmitGuard = "true";
  form.addEventListener("submit", (event) => event.preventDefault());
  form.addEventListener("pointerdown", preserveScroll, true);
  form.addEventListener("click", preserveScroll, true);
  form.addEventListener("change", preserveScroll, true);
  setAlgoliaFilterButtonTypes(form);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        pending.push(node);
      }
    }
    frame ?? (frame = window.requestAnimationFrame(flush));
  });
  observer.observe(form, { childList: true, subtree: true });
}
function bootstrapAlgoliaFilterForms(root = document) {
  root.querySelectorAll(ALGOLIA_FILTER_FORM_SELECTOR).forEach(setupAlgoliaFilterForm);
}

// src/sections/algolia-filter/algolia-filter.ts
bootstrapAlgoliaFilterForms();
